import React from "react";
import Header from "../../components/Header";
import Firebase from "../../firebasehelper";
import "./index.css";
import EditSuperAdminModal from "../../components/EditSuperAdminModal";
import AddUserModal from "../../components/AddUserModal";
import ResetPasswordSuperAdminModal from "../../components/ResetPasswordSuperAdminModal";
import {
  removeTaskerFromAuth,
  updateRetailerAdminLead,
  resetPassword,
} from "../../api/UserApi";

const user_icon = require("../../assets/media/user.png");
const remove_icon = require("../../assets/media/stop.png");

class SuperAdmins extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      superAdmins: [],
    };
  }

  componentDidMount() {
    if (!this.props.location.state) {
      this.props.history.push("/");
    } else {
      const { brand, role, username } = this.props.location.state;
      this.setState({ username, role, brand });

      Firebase.getAllAgencies((res) => {
        this.setState({ superAdmins: res.filter((obj) => obj.role === 0) });
      });
    }
  }

  addSubAdmin = (name, email, password) => {
    Firebase.addAgency(email, password)
      .then((uid) => {
        Firebase.writeAgencydata(uid, {
          uid: uid,
          username: name,
          email,
          role: 0,
          approved: true,
        });
      })
      .catch((err) => {
        alert(err);
      });
  };

  onEditUser = (username, email) => {
    const { selectedUser } = this.state;
    if (selectedUser) {
      console.log(selectedUser);
      Firebase.updateAgencyData(selectedUser.uid, {
        username,
        email,
      });

      updateRetailerAdminLead(selectedUser.uid, email);
    }
  };

  onResetPassword = (password) => {
    const { selectedUser } = this.state;
    if (selectedUser) {
      resetPassword(selectedUser.uid, password).catch(() => {
        console.log("Something went wrong!");
      });
    }
  };

  removeSuperAdmin = (item) => () => {
    const { uid } = item;
    Firebase.removeAgency(uid);
    removeTaskerFromAuth(uid);
  };

  editSuperAdmin = (item) => () => {
    this.setState({
      selectedUser: item,
    });
  };

  render() {
    const {
      username,
      role,
      logo,
      brand,
      brand_name,
      superAdmins,
      selectedUser,
    } = this.state;
    return (
      <div id="page-container">
        <Header
          username={username}
          role={role}
          logo={logo}
          brand={brand}
          brandName={brand_name}
        />
        <main id="main-container">
          <div className="home-content super-admins-container">
            <div className="user-content">
              <div>
                <div className="member-row">
                  <button
                    type="button"
                    className="btn add-user"
                    data-toggle="modal"
                    data-target="#add_user"
                  >
                    Add Super Admin
                  </button>
                </div>
                <div className="member-row">
                  <p className="avatar-header">Profile</p>
                  <p className="member-name">Name</p>
                  <p className="member-email">Email</p>
                  <p className="member-name">UID</p>
                  <div className="sa-actions-container"></div>
                </div>
                {superAdmins.map((item) => {
                  return (
                    <div className="member-row">
                      <img
                        className="avatar-header"
                        src={user_icon}
                        width="50"
                        alt="icon"
                      />
                      <div className="member-name name-container">
                        <p>{item.username}</p>
                        <img
                          src={remove_icon}
                          className="remove-icon"
                          alt="remove"
                          onClick={this.removeSuperAdmin(item)}
                        />
                      </div>
                      <p className="member-email">{item.email}</p>
                      <p className="member-name">{item.uid}</p>
                      <div className="sa-actions-container">
                        <button
                          type="button"
                          class="btn"
                          data-toggle="modal"
                          data-target="#edit_super_admin"
                          onClick={this.editSuperAdmin(item)}
                        >
                          Edit
                        </button>
                        <button
                          type="button"
                          class="btn"
                          data-toggle="modal"
                          data-target="#reset_password_super_admin"
                          onClick={this.editSuperAdmin(item)}
                        >
                          Reset password
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </main>
        <AddUserModal addUser={this.addSubAdmin} />
        <EditSuperAdminModal
          onSave={this.onEditUser}
          initialValues={selectedUser}
        />
        <ResetPasswordSuperAdminModal
          onSave={this.onResetPassword}
          initialValues={selectedUser}
        />
      </div>
    );
  }
}
export default SuperAdmins;



// WEBPACK FOOTER //
// ./src/screens/SuperAdmins/index.js